import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    personalizedSidebarBannerEnabled,
    personalizedTopBannerEnabled,
} from 'reactApp/appHelpers/featuresHelpers/features/personalization';
import { useFamilyShowFeaturesHook } from 'reactApp/hooks/useFamilyShowHook';
import { initPersonalTariffs } from 'reactApp/modules/billingPersonalization/billingPersonalization.module';
import { BillingPersonalizationSelectors } from 'reactApp/modules/billingPersonalization/billingPersonalization.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';

export const usePersonalizationInit = () => {
    const dispatch = useDispatch();

    const { isLoaded: isPersonalizationLoaded, isLoading: isPersonalizationLoading } = useSelector(
        BillingPersonalizationSelectors.getLoadingState
    );
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const isCorpUser = useSelector(UserSelectors.isCorpUser);
    const isBizUser = useSelector(UserSelectors.isBizUser);
    const isFamilyUser = useFamilyShowFeaturesHook();

    useEffect(() => {
        if (
            (!personalizedSidebarBannerEnabled && !personalizedTopBannerEnabled) ||
            !isPaidUser ||
            isCorpUser ||
            isBizUser ||
            isFamilyUser
        ) {
            return;
        }

        if (!isPersonalizationLoaded && !isPersonalizationLoading) {
            dispatch(initPersonalTariffs());
        }
    }, [dispatch, isPersonalizationLoaded, isPersonalizationLoading, isPaidUser, isCorpUser, isBizUser, isFamilyUser]);
};
